'use client';

/**
 * Public product-context API for child components.
 *
 * Import from here, not from `./context/*` internals.
 */
export { ProductProvider } from './context/product-provider';
export { useProduct } from './context/use-product';
export { useSelectionActions } from './context/use-selection-actions';
export { useSelectedVariant } from './context/use-selected-variant';
export { useResolvedSearchParams } from './context/use-resolved-search-params';
export { useAdditionalProducts } from './context/use-additional-products';
export { useSelectedQuantity } from './context/use-selected-quantity';
export { useBundleSelection } from './context/use-bundle-selection';
